module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_gearlounge_m.c261f847bed8b8a7c48efc1bc5631c54.png";